import axios from '../utils/request'

import fileUploadAxios from '../utils/fileRequest'

import requestHeader from '../utils/requestHeader'
import { message } from 'ant-design-vue'

const baseRequest = (url, methodType, params, options, isShowErrorNotify) => {
  axios.defaults.withCredentials = true
  if (typeof isShowErrorNotify === 'undefined') {
    isShowErrorNotify = true
  }

  //redirectLogin: 当http 401或者response.code=401则跳转到学校登录页
  let request = {
    url: url,
    method: methodType,
    headers: requestHeader.createHeaders(params),
    showErrorNotify: isShowErrorNotify,
    redirectLogin: true,
  }
  if (options != null) {
    for (let key in options) {
      request[key] = options[key]
    }
  }

  if (params != null) {
    var formData = null
    for (let key in params) {
      //如果有文件，则使用FormData
      if (params[key] instanceof File) {
        formData = new FormData()
        break
      }
    }
    if (formData == null) {
      //非文件上传操作使用URLSearchParams
      formData = new URLSearchParams()
    }
    for (let key in params) {
      formData.append(key, params[key])
    }
    //如果是post请求，以formdata的形式传递
    if (methodType.toUpperCase() == 'GET') request.params = formData
    else request.data = formData
  }
  return axios(request)
}
const baseRequest2 = (url, methodType, params, options, isShowErrorNotify) => {
  axios.defaults.withCredentials = true
  if (typeof isShowErrorNotify === 'undefined') {
    isShowErrorNotify = true
  }

  //redirectLogin: 当http 401或者response.code=401则跳转到学校登录页
  let request = {
    url: url,
    method: methodType,
    headers: requestHeader.createHeaders(params),
    showErrorNotify: isShowErrorNotify,
    redirectLogin: true,
  }
  if (options != null) {
    for (let key in options) {
      request[key] = options[key];
    }
  }

  if (params != null) {
    // 检查是否有文件
    let hasFile = false;
    for (let key in params) {
      if (params[key] instanceof File) {
        hasFile = true;
        break;
      }
    }

    if (hasFile) {
      // 如果有文件，使用 FormData
      let formData = new FormData();
      for (let key in params) {
        if (params[key] instanceof File) {
          formData.append(key, params[key]);
        } else {
          // 将嵌套对象转换为 JSON 字符串
          formData.append(key, JSON.stringify(params[key]));
        }
      }
      request.data = formData;
    } else {
      // 如果没有文件，直接发送 JSON 数据
      request.headers['Content-Type'] = 'application/json'; // 设置请求头为 JSON
      request.data = params; // 将 params 作为请求体
    }
  }

  return axios(request)
}

const fileRequest = (url, params, options, isShowErrorNotify) => {
  return baseRequest(url, 'post', params, options, isShowErrorNotify)
}
const fileUploadRequest = async (url, params, options, isShowErrorNotify) => {
  if (!options) {
    options = {}
  }
  options.responseType = 'blob'
  const data = await baseRequest(
    url,
    'post',
    params,
    options,
    isShowErrorNotify
  )
  if (!data.data.size) {
    message.error('服务器异常')
  }
  return data
}
function saveDownloadFile(axiosResponse) {
  const blob = new Blob([axiosResponse.data], {
    type: axiosResponse.headers['content-type'],
  })
  const contentDisposition = axiosResponse.headers['content-disposition'] //注意axios文档，头部获取需小写
  let link = document.createElement('a')
  let fileName = 'file.dat'
  if (contentDisposition) {
    const descArrays = contentDisposition.split('=')
    fileName = decodeURI(descArrays[1])
  }
  link.style.display = 'none'
  document.body.appendChild(link)
  link.href = window.URL.createObjectURL(blob)
  link.download = fileName
  link.click()
  // window.URL.revokeObjectURL(link.href);
}
export { baseRequest, fileRequest, fileUploadRequest, saveDownloadFile,baseRequest2 }
